<button mat-icon-button  #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu">
  <mat-icon>filter_alt</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <ng-template matMenuContent>
    <form [formGroup]="form" (click)="$event.stopPropagation()">
      <div class="menu-header">Filter by</div>

      <mat-form-field>
        <mat-select formControlName="filter">
          @for (option of filterOptions(); track option) {
            <mat-option [value]="option.type">{{ option.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (showStringInput) {
        <mat-form-field>
          <input matInput formControlName="value" />
        </mat-form-field>
      }

      @if (showDateInput) {
        <mat-form-field class="full-width">
          <input matInput formControlName="value" [matDatepicker]="datePickerFrom">
          <mat-datepicker-toggle matSuffix [for]="datePickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #datePickerFrom></mat-datepicker>
        </mat-form-field>
      }

      @if (showDateRangeInput) {
        <mat-form-field class="full-width">
          <input matInput formControlName="value" [matDatepicker]="datePickerRangeFrom" placeholder="From">
          <mat-datepicker-toggle matSuffix [for]="datePickerRangeFrom"></mat-datepicker-toggle>
          <mat-datepicker #datePickerRangeFrom></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="full-width">
          <input matInput formControlName="valueTo" [matDatepicker]="datePickerRangeTo" placeholder="To">
          <mat-datepicker-toggle matSuffix [for]="datePickerRangeTo"></mat-datepicker-toggle>
          <mat-datepicker #datePickerRangeTo></mat-datepicker>
        </mat-form-field>
      }

      @if (showNumberInput) {
        <mat-form-field>
          <input matInput type="number" formControlName="value" placeholder="Value" aria-label="Numeric filter value" />
        </mat-form-field>
      }

      @if (showNumberRangeInput) {
        <mat-form-field>
          <input matInput type="number" formControlName="value" placeholder="From" aria-label="Numeric filter from value" />
        </mat-form-field>
        <mat-form-field>
          <input matInput type="number" formControlName="valueTo" placeholder="To" aria-label="Numeric filter to value" />
        </mat-form-field>
      }

      @if (showMultiSelectInput) {
        <mat-form-field>
          <mat-label>Select values</mat-label>
          <mat-select formControlName="values" multiple aria-label="Select values">
            @for (option of options(); track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <div class="filter-controls">
        <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
        @if (isApplied) {
          <button mat-flat-button type="button" (click)="reset()">Reset</button>
        } @else {
          <button mat-flat-button type="button" (click)="apply()">Apply</button>
        }
      </div>
    </form>
  </ng-template>
</mat-menu>
